/**
 * Created: 2026-04-07
 * Initial commit: Add formatEventTimeRange date utility
 *
 * Shared date formatting utilities for the frontend.
 */

import { addHours, format } from 'date-fns'
import { zhCN } from 'date-fns/locale'

/**
 * Get weekday text in Chinese format (周一, 周二, etc.)
 * Accepts a Date or a date string in YYYY-MM-DD format.
 */
export function getWeekdayText(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(`${date}T00:00:00`) : date
  return format(d, 'EEE', { locale: zhCN })
}

/**
 * Format a start time and duration into a human-readable range string.
 * Example: '2026-04-14 周二 15:00-16:00'
 */
export function formatEventTimeRange(
  startTime: string | Date,
  duration: number,
): string {
  const start = new Date(startTime)
  const end = addHours(start, duration)
  return `${format(start, 'yyyy-MM-dd EEE HH:mm', { locale: zhCN })}-${format(end, 'HH:mm')}`
}
